const UA = navigator.userAgent.toUpperCase();
export const IS_ANDROID = UA.indexOf("ANDROID") !== -1;

/**
 * 设置本地数据
 * @exports setStorageSync
 * @param {string} key
 * @param {*} val
 * @returns {string}
 */
export const setStorageSync = function(key: string, val: any): string | null {
  if (!key) {
    throw "setStorageSync: key is null";
  }
  if (!val) {
    console.log("请注意，${key} 为 null | undefined | false");
  }
  // wx.setStorageSync(key, val);
  let value = null;
  if (typeof val === typeof {}) {
    value = JSON.stringify(val);
  } else {
    value = String(val);
  }
  localStorage.setItem(key, value);
  return localStorage.getItem(key);
};

/**
 * 设置本地数据
 * @exports getStorageSync
 * @param {string} key
 * @param {*} val
 * @returns {string}
 */
export const getStorageSync = function(key: string): string | null {
  if (!key) {
    throw "getStorageSync: key is null";
    //return undefined;
  }
  // wx.setStorageSync(key, val);
  return localStorage.getItem(key);
};

export const delStorageSync = function(key: string) {
  if (!key) {
    throw "getStorageSync: key is null";
    //return undefined;
  }
  // wx.setStorageSync(key, val);
  return localStorage.removeItem(key);
};

/**
 * 弹出一个提示信息
 * @param message 提示信息
 */
export const Falert = function(message: string) {
  const dom = document.querySelector("#toolAlert") as HTMLDivElement;
  const debugDom = dom ? dom : createAlertDom();
  debugDom.style.display = "block";
  const messageDom = document.querySelector("#toolmessage") as Element;
  messageDom.innerHTML = typeof message === typeof {} ? JSON.stringify(message) : message;
  //debugDom.appendChild(messageDom);

  function createAlertDom(): HTMLDivElement {
    let dom = document.createElement("div");
    dom.id = "toolAlert";

    dom.style.cssText =
      "display:none;background:rgba(0,0,0,.5);height:100%;width:100%;overflow:auto;position:fixed;left:0;top:0;z-index:99999";
    dom.innerHTML = `
        <div style="width: 400px;margin: 30px auto 0;background:#eeeeee;border-radius: 10px;">
            <h4 id="toolmessage" style="padding: 20px 3px;text-align: center;word-break:break-all;"></h4>
            <p style="text-align: center;padding: 10px 0;border-top:1px solid #e6e2e2;">知道了</p>
        </div>    
    `;
    const body = document.querySelector("body") as HTMLBodyElement;
    body.appendChild(dom);
    dom.addEventListener(
      "click",
      function(ev: any) {
        console.log(ev.target);

        if (ev && ev.target && ev.target.nodeName.toUpperCase() === "P") {
          dom.style.display = "none";
        }
      },
      false
    );
    dom.addEventListener(
      "touchmove",
      function(ev) {
        // ev.preventDefault();
        // ev.stopPropagation();
        return false;
      },
      false
    );
    //dom.innerHTML = message;
    return dom;
  }
};

/**
 * 复制文本
 * @param text 要复制的数据
 */
export const copy = (text: string) => {
  const input = document.createElement("input");
  input.setAttribute("readonly", "readonly");
  input.setAttribute("value", text);
  document.body.appendChild(input);
  input.setSelectionRange(0, 9999);
  if (document.execCommand("copy")) {
    document.execCommand("copy");
    Falert("复制成功");
  }
  document.body.removeChild(input);
};
